import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Url } from "./../common/url";

@Injectable({
  providedIn: "root",
})
export class DataService {
  constructor(private urlResource: string, private http: HttpClient) {}

  url: string = Url[this.urlResource];

  getAll() {
    return this.http.get(this.url);
  }

  create(resource: any) {
    return this.http.post(this.url, resource);
  }

  update(resource) {
    return this.http.put(this.url + "/" + resource.id, resource);
  }

  delete(id: string) {
    return this.http.delete(this.url + "/" + id);
  }

  getById(id: string) {
    return this.http.get(this.url + "/" + id);
  }
}
